'use strict'

/**
 * LCHColor
 * Workflow: lightweight value container for LCH components.
 */
class LCHColor {
    /**
     * @param {number} l Lightness (0..100).
     * @param {number} c Chroma.
     * @param {number} h Hue in degrees.
     */
    constructor(l = 0.0, c = 0.0, h = 0.0) {
        this.l = l
        this.c = c
        this.h = h
    }
}

export default LCHColor
